module.exports = ".type{\n    text-align: center;\n    background-color: #929292;\n    color:white;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/questions-type/section-break-type/section-break-type.css
// module id = ./src/app/questions-type/section-break-type/section-break-type.css
// module chunks = main